module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_7-1039153bdb11dd2e8f3daa5ddf517e08.jpg";